import { render } from "./PopUp.vue?vue&type=template&id=3491ee41&scoped=true"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=3491ee41&lang=css"
import "./PopUp.vue?vue&type=style&index=1&id=3491ee41&lang=scss&scoped=true"
import "./PopUp.vue?vue&type=style&index=2&id=3491ee41&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3491ee41"]])

export default __exports__